import { useQuery } from '@tanstack/react-query';

import ProductsService, {
  SemanticSearchFilters,
} from '@/services/ProductsService';

export const GET_SEMANTIC_SEARCH_FILTERS_QUERY_KEY = (
  semanticFilters?: SemanticSearchFilters,
) => ['semantic-search-filters', semanticFilters];

export function useGetSemanticSearchFilters(
  semanticFilters: SemanticSearchFilters,
  enabled: boolean,
) {
  const { data, isFetching } = useQuery({
    queryKey: GET_SEMANTIC_SEARCH_FILTERS_QUERY_KEY(semanticFilters),
    queryFn: () => ProductsService.getSemanticSearchFilters(semanticFilters),
    enabled,
  });

  return {
    semanticSearchFilters: data,
    isFetchingSemanticSearchFilters: isFetching,
  };
}
